import moment from "moment";
import constant from "../../../../../constants/constant";
import atoms from "../../../../atoms";
import { InventoryDetailProps } from "../interface";

const { Select, Input, FileInput } = atoms;

export const InventoryDetail: React.FC<InventoryDetailProps> = ({
    typeValue,
    invoiceData,
    errors,
    storeData,
    supplierData,
    handleSearch,
    handleChange,
    setRegionCode,
    search,
    fileRef,
    handleFileChange
}) => {
    return (
        <div className="row">
            <div className="col-3 mt-3">
                <Select
                    label={"Category"}
                    className={"w-100"}
                    placeholder={"Select Category"}
                    options={
                        typeValue === "true"
                            ? constant.INVOICE_CATEGORY
                            : constant.UNRECOGNIZED_INVOICE_CATEGORY
                    }
                    value={invoiceData?.category}
                    errors={errors.category}
                    onChange={(e: any) => {
                        handleChange("category", e);
                    }}
                />
            </div>
            <div className="col-3 mt-3">
                <Select
                    label={"Physical Inventory Store"}
                    className={"w-100"}
                    placeholder={"Select Store"}
                    options={storeData && storeData}
                    value={invoiceData?.store_id}
                    errors={errors.store_id}
                    onChange={(e: any) => {
                        handleChange("store_id", e);
                        handleSearch(search);
                        setRegionCode(e.region_code);
                    }}
                />
            </div>
            <div className="col-3 mt-3">
                <Select
                    label={"Supplier"}
                    className={"w-100 zIndex-3"}
                    placeholder={"Select Supplier"}
                    options={supplierData && supplierData}
                    value={invoiceData?.supplier_id}
                    errors={errors.supplier_id}
                    onChange={(e: any) => {
                        handleChange("supplier_id", e);
                    }}
                />
            </div>
            <div className="col-3 mt-3">
                <Input
                    label={
                        invoiceData?.category?.label === "SAMPLE"
                            ? "Delivery Challan"
                            : invoiceData?.category?.label === "WARRANTY"
                                ? "Claim ID"
                                : invoiceData?.category?.label === "FREE GOODS"
                                    ? "Ref. Supplier Invoice Number"
                                    : "Supplier Invoice Number"
                    }
                    type={"text"}
                    placeholder={
                        invoiceData?.category?.label === "SAMPLE"
                            ? " Enter Delivery Challan"
                            : invoiceData?.category?.label === "WARRANTY"
                                ? " Enter Claim ID"
                                : invoiceData?.category?.label === "FREE GOODS"
                                    ? "Enter Supplier Invoice Number"
                                    : "Enter Invoice Number"
                    }
                    value={invoiceData?.supplier_invoice_number}
                    errors={errors.supplier_invoice_number}
                    onChange={(e: any) => {
                        handleChange("supplier_invoice_number", e.target.value);
                    }}
                />
            </div>
            <div className="col-3 mt-3">
                <Input
                    label={"Invoice Date"}
                    placeholder={"Enter Invoice Date"}
                    type="date"
                    value={moment(invoiceData?.supplier_invoice_date).format("YYYY-MM-DD")}
                    errors={errors.supplier_invoice_date}
                    onChange={(e: any) => {
                        handleChange("supplier_invoice_date", e);
                    }}
                />
            </div>
            <div className="col-6 mt-3">
                <div className="d-flex">
                    <FileInput
                        label={"Invoice File"}
                        type="file"
                        fileRef={fileRef}
                        accept={
                            "image/png, image/jpg, image/jpeg, image/webp, application/pdf"
                        }
                        // errors={errors.invoice_file}
                        onChange={(e: any) => handleFileChange(e)}
                        multiple={true}
                    />
                </div>
            </div>
        </div>
    );
};
